import { render, staticRenderFns } from "./dashboardProductivity.vue?vue&type=template&id=67192fac"
import script from "./dashboardProductivity.vue?vue&type=script&lang=js"
export * from "./dashboardProductivity.vue?vue&type=script&lang=js"
import style0 from "./dashboardProductivity.vue?vue&type=style&index=0&id=67192fac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports